(() => {
'use strict';
if (window.ssInitialized) return;
window.ssInitialized = true;
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const autoVideo = !reduced && !navigator.connection?.saveData;
const playMemory = player => { if(autoVideo && !player.closest('[hidden]') && !document.hidden) player.ssPlay?.(true); };
const videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
  entries.forEach(entry => { if(entry.isIntersecting && entry.target.dataset.ssAutoplay === 'true') playMemory(entry.target); else entry.target.ssPause?.(); });
}, {threshold:.25}) : null;
const reveals = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
  entries.forEach(entry => { if (entry.isIntersecting) {entry.target.classList.remove('is-pending'); reveals.unobserve(entry.target);} });
}, {threshold: .08}) : null;
function init(root = document) {
  root.querySelectorAll('[data-ss-money]').forEach(node=>{const amount=Number(node.dataset.ssMoney);if(Number.isFinite(amount))node.textContent=new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:node.dataset.ssCurrency||'EUR'}).format(amount/100);});
  root.querySelectorAll('[data-ss-player]:not([data-ss-player-ready])').forEach(player => {
    player.dataset.ssPlayerReady = 'true';
    const cover = player.querySelector('[data-ss-video-start]');
    const toggle = player.querySelector('[data-ss-video-toggle]');
    const sound = player.querySelector('[data-ss-video-sound]');
    const controls = player.querySelector('[data-ss-video-controls]');
    const error = player.querySelector('[data-ss-video-error]');
    let video, userPaused = false, manualStarted = false;
    const sync = () => {
      if(!video) return;
      player.classList.toggle('ss-is-playing',!video.paused);
      cover.setAttribute('aria-label',video.paused ? player.dataset.play : player.dataset.pause);
      cover.setAttribute('aria-pressed',String(!video.paused));
      toggle.setAttribute('aria-label',video.paused ? player.dataset.play : player.dataset.pause);
      toggle.querySelector('span').textContent = video.paused ? player.dataset.play : player.dataset.pause;
      sound.setAttribute('aria-pressed',String(!video.muted));
      sound.setAttribute('aria-label',video.muted ? player.dataset.soundOn : player.dataset.soundOff);
      sound.querySelector('span').textContent = video.muted ? player.dataset.soundOn : player.dataset.soundOff;
    };
    const mount = () => {
      if(video) return;
      const fragment = player.querySelector('[data-ss-video-template]').content.cloneNode(true);
      player.prepend(fragment);
      video = player.querySelector('video');
      video.setAttribute('aria-label',cover.querySelector('img')?.alt || 'SoulSphere');
      video.controls = false;
      video.loop = true;
      video.autoplay = player.dataset.ssAutoplay === 'true';
      controls.hidden = false;
      video.addEventListener('playing',()=>{player.classList.add('ss-has-played');cover.hidden=false;sync();});
      video.addEventListener('pause',()=>{cover.hidden=false;sync();});
      video.addEventListener('ended',()=>{cover.hidden=false;sync();});
      video.addEventListener('volumechange',sync);
      video.addEventListener('timeupdate',()=>{const ratio=Number.isFinite(video.duration) && video.duration>0 ? video.currentTime/video.duration : 0;player.querySelector('[data-ss-video-progress]').style.transform='scaleX('+ratio+')';});
      video.addEventListener('error',()=>{error.textContent=player.dataset.failed;error.hidden=false;cover.hidden=false;});
      sync();
    };
    player.ssPlay = automatic => {
      if(automatic && (!autoVideo || userPaused || player.closest('[hidden]') || document.hidden)) return;
      mount();
      if(!automatic){userPaused=false;if(!manualStarted){video.muted=player.dataset.ssAutoplay==='true';manualStarted=true;}}
      error.hidden=true;
      video.play().catch(()=>{cover.hidden=false;sync();if(!automatic){error.textContent=player.dataset.failed;error.hidden=false;}});
    };
    player.ssPause = () => video?.pause();
    const togglePlayback = () => {if(!video || video.paused)player.ssPlay(false);else{userPaused=true;video.pause();}};
    cover.addEventListener('click',togglePlayback);
    toggle.addEventListener('click',togglePlayback);
    sound.addEventListener('click',()=>{if(!video)return;video.muted=!video.muted;sync();});
    if(videoObserver)videoObserver.observe(player);
    else if(player.dataset.ssAutoplay==='true'){const rect=player.getBoundingClientRect();if(rect.top<innerHeight && rect.bottom>0)playMemory(player);}
  });
  if (reveals && !reduced) root.querySelectorAll('.ss-reveal:not([data-ss-revealed])').forEach(el => {
    el.dataset.ssRevealed = 'true';
    if (el.getBoundingClientRect().top > innerHeight) {el.classList.add('is-pending'); reveals.observe(el);}
  });
  root.querySelectorAll('[data-ss-tabs]:not([data-ss-ready])').forEach(el => {
    el.dataset.ssReady = 'true';
    const tabs = [...el.querySelectorAll('[data-ss-tab]')];
    const activate = tab => {
      tabs.forEach(t => {const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; const panel = document.getElementById(t.getAttribute('aria-controls')); if(panel) {panel.hidden = !active; panel.querySelectorAll('[data-ss-player]').forEach(player => {if(!active) player.ssPause?.(); else {const rect=player.getBoundingClientRect();if(rect.top<innerHeight && rect.bottom>0) playMemory(player);}});}});
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', e => {
        let next;
        if(e.key === 'ArrowRight') next = tabs[(i+1)%tabs.length];
        if(e.key === 'ArrowLeft') next = tabs[(i-1+tabs.length)%tabs.length];
        if(e.key === 'Home') next = tabs[0];
        if(e.key === 'End') next = tabs[tabs.length-1];
        if(next) {e.preventDefault(); activate(next); next.focus();}
      });
    });
  });
  root.querySelectorAll('[data-ss-product]:not([data-ss-ready])').forEach(el => {
    el.dataset.ssReady = 'true';
    const data = JSON.parse(el.querySelector('[data-ss-variants]').textContent);
    const form = el.querySelector('.ss-product-form');
    const image = el.querySelector('.ss-main-image img');
    const qty = form.querySelector('[name=quantity]');
    const add = form.querySelector('[data-ss-add]');
    const addLabel = form.querySelector('[data-ss-add-label]');
    const error = form.querySelector('[data-ss-error]');
    const photoLabel = el.querySelector('[data-ss-photo-label]');
    const packs = form.querySelector('[data-ss-packs]');
    const second = form.querySelector('[data-ss-second]');
    const first = form.querySelector('[data-ss-first]');
    const swatches = form.querySelector('.ss-variant-fieldset');
    const secondWrap = form.querySelector('[data-ss-second-wrap]');
    const packCaption = form.querySelector('[data-ss-quantity-caption]');
    const stock = el.querySelector('[data-ss-stock]');
    let current;
    const isDuo = () => !!packs && form.querySelector('[name=ss_pack]:checked')?.value === '2';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'es', {style:'currency',currency:el.dataset.currency || 'EUR'}).format(cents/100);
    const syncPack = () => {
      if(!current) return;
      const duo = isDuo();
      const other = data.find(v => String(v.id) === second?.value);
      if(secondWrap) secondWrap.hidden = !duo;
      if(second) second.disabled = !duo;
      if(first) {first.disabled = !duo; first.value = String(current.id);}
      if(swatches) swatches.hidden = duo;
      if(packCaption) packCaption.hidden = !duo;
      
      let max = current.tracked ? current.quantity : Infinity;
      if(duo && other) max = current.id === other.id ? (current.tracked ? Math.floor(current.quantity/2) : Infinity) : Math.min(max, other.tracked ? other.quantity : Infinity);
      if(Number.isFinite(max)) qty.max = Math.max(1,max); else qty.removeAttribute('max');
      qty.value = Math.max(1,Math.min(Math.floor(Number(qty.value))||1,max || 1));
      const available = current.available && (!duo || (other?.available && max > 0));
      add.disabled = !available;
      addLabel.textContent = available ? (duo ? el.dataset.duoBuy : el.dataset.buy) : el.dataset.sold;
      stock.dataset.available = String(available);
      stock.textContent = available ? (duo ? (Number.isFinite(max) ? max + ' ' + el.dataset.packsStock : el.dataset.packAvailable) : (current.tracked ? current.quantity + ' ' + el.dataset.stockLabel : el.dataset.stockLabel)) : el.dataset.sold;
      const total = duo && other ? (current.cents + other.cents - Number(el.dataset.duoSaving)) * Number(qty.value) : current.cents * Number(qty.value) - (packs ? Math.floor(Number(qty.value)/2) * Number(el.dataset.duoSaving) : 0);
      el.querySelector('[data-ss-price]').textContent = money(total);
      const comparison = el.querySelector('[data-ss-compare]');
      comparison.hidden = duo || Number(qty.value)>1 || !current.onSale;
      el.querySelector('[data-ss-sticky-price]')?.replaceChildren(document.createTextNode(money(total)));
      el.querySelector('[data-ss-sticky-color]')?.replaceChildren(document.createTextNode(duo ? current.title + ' + ' + (other?.title || '') : current.title));
      qty.setAttribute('aria-label',duo ? el.dataset.packLabel : el.dataset.unitLabel);
    };
    const changeImage = (src, alt, variant) => {
      if(!image || !src) return;
      image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = src; image.alt = alt;
      image.classList.toggle('ss-selected-photo', variant);
      image.classList.toggle('ss-editorial-photo', !variant);
      const context=el.querySelector('[data-ss-image-context]');
      if(context) context.hidden=variant || !/Escena ilustrativa|Infografía|Composición retocada/.test(alt);
      photoLabel.textContent = variant ? alt : '';
      el.querySelectorAll('[data-ss-thumb]').forEach(t => t.setAttribute('aria-pressed', String(new URL(t.dataset.src, location.origin).pathname === new URL(src, location.origin).pathname)));
    };
    const setVariant = (id, updateUrl = true) => {
      const v = data.find(item => String(item.id) === String(id));
      if(!v) return;
      current = v;
      el.querySelectorAll('[data-ss-variant]').forEach(input => {input.checked = String(input.value) === String(v.id);});
      el.querySelector('[data-ss-price]').textContent = v.price;
      const comparison = el.querySelector('[data-ss-compare]'); comparison.textContent = money(v.compareCents || 0); comparison.hidden = !v.onSale;
      el.querySelector('[data-ss-color]')?.replaceChildren(document.createTextNode(v.title));
      el.querySelector('[data-ss-stock]').textContent = v.available ? (v.tracked ? v.quantity + ' ' + el.dataset.stockLabel : el.dataset.stockLabel) : el.dataset.sold;
      if(v.tracked) qty.max = Math.max(1,v.quantity); else qty.removeAttribute('max');
      qty.value = Math.max(1, Math.min(Number(qty.value) || 1, Number(qty.max) || Infinity));
      add.disabled = !v.available; addLabel.textContent = v.available ? el.dataset.buy : el.dataset.sold;
      error.hidden = true;
      el.querySelector('[data-ss-sticky-price]')?.replaceChildren(document.createTextNode(v.price));
      el.querySelector('[data-ss-sticky-color]')?.replaceChildren(document.createTextNode(v.title));
      if(updateUrl || el.querySelector('[data-ss-hero-initial]')?.dataset.ssHeroInitial!=='true') changeImage(v.image, v.title, true);
      syncPack();
      if(updateUrl && location.pathname.includes('/products/')) {const url = new URL(location.href); url.searchParams.set('variant',v.id); history.replaceState({},'',url);}
    };
    el.querySelectorAll('[data-ss-variant]').forEach(radio => radio.addEventListener('change', () => setVariant(radio.value)));
    el.querySelectorAll('[data-ss-thumb]').forEach(thumb => thumb.addEventListener('click', () => { if(thumb.dataset.variantId) setVariant(thumb.dataset.variantId); else changeImage(thumb.dataset.src,thumb.dataset.alt,false); }));
    if(packs) {packs.hidden = false; packs.querySelectorAll('[name=ss_pack]').forEach(r => r.addEventListener('change',()=>{qty.value=1;syncPack();changeImage(current.image,current.title,true);}));}
    first?.addEventListener('change',()=>setVariant(first.value));
    second?.addEventListener('change',()=>{syncPack();const v=data.find(v=>String(v.id)===second.value);if(v) changeImage(v.image,v.title,true);});
    el.querySelectorAll('[data-ss-quantity]').forEach(button => button.addEventListener('click', () => {
      qty.value = Math.max(1,Math.min((Number(qty.value)||1) + Number(button.dataset.ssQuantity),Number(qty.max)||Infinity)); syncPack();
    }));
    qty.addEventListener('change',()=>{qty.value = Math.max(1,Math.min(Number(qty.value)||1,Number(qty.max)||Infinity));syncPack();});
    qty.addEventListener('input',()=>{if(qty.value && Number(qty.value)>0)syncPack();});
    form.addEventListener('submit', async e => {
      if(!window.fetch) return;
      e.preventDefault(); if(add.disabled) return; add.disabled = true; addLabel.textContent = el.dataset.loading; error.hidden = true;
      try {
        const count = Math.max(1,Math.floor(Number(qty.value))||1);
        const items = [{id:current.id,quantity:count}];
        if(isDuo()) {
          const other = data.find(v=>String(v.id)===second.value);
          if(other.id===current.id) items[0].quantity*=2; else items.push({id:other.id,quantity:count});
        }
        const response = await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',body:JSON.stringify({items}),headers:{Accept:'application/json','Content-Type':'application/json'}});
        const result = await response.json();
        if(!response.ok) throw new Error(result.description || el.dataset.error);
        location.assign(el.dataset.cartUrl);
      } catch(err) {
        error.textContent = err.message || el.dataset.error; error.hidden = false; syncPack();
      }
    });
    const selected = form.querySelector('[name=id]:checked') || form.querySelector('[name=id]');
    if(selected) setVariant(selected.value,false);
    el.querySelector('[data-ss-jump]')?.addEventListener('click', () => {
      form.scrollIntoView({behavior:reduced?'instant':'smooth',block:'center'});
      const selectedControl = isDuo() ? first : form.querySelector('[name=id]:checked'); selectedControl?.focus({preventScroll:true});
    });
    const sticky = el.querySelector('[data-ss-sticky]');
    if(sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        sticky.classList.toggle('is-visible',!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }),{threshold:0});
      observer.observe(form);
      el.ssObserver = observer;
    }
  });
  root.querySelectorAll('.ss-mobile-links a').forEach(a => a.addEventListener('click', () => a.closest('details').removeAttribute('open')));
}
document.addEventListener('DOMContentLoaded', () => init());
document.addEventListener('shopify:section:load', e => init(e.target));
document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('[data-ss-product]').forEach(el=>el.ssObserver?.disconnect());e.target.querySelectorAll('[data-ss-player]').forEach(player=>{videoObserver?.unobserve(player);player.ssPause?.();});});
document.addEventListener('visibilitychange',()=>{document.querySelectorAll('[data-ss-player]').forEach(player=>{if(document.hidden)player.ssPause?.();else{const rect=player.getBoundingClientRect();if(player.dataset.ssAutoplay==='true' && rect.top<innerHeight && rect.bottom>0)playMemory(player);}});});
if(document.readyState !== 'loading') init();
})();
